import React, {Component} from 'react'
import ReactTable from 'react-table'
import {Query, SubscriptionWrapper} from 'react-apollo'
import {debounce} from 'lodash'
import {withRouter} from "react-router-dom"
import 'react-table/react-table.css'

import AUSelectGenerator from '../auto_updaters/Select'
import QUERY from '../../../queries/server/filter_users'
//import SUBSCRIPTION from '../../../queries/server/subscriptions/project_upserted'

const AUSelectOffice = AUSelectGenerator('offices', 'id description', 'id', ['description'])
const AUSelectUserRoles = AUSelectGenerator('user_roles', 'user_role_id description', 'user_role_id', ['description'])
const AUSelectUsers = AUSelectGenerator('users', 'user_id first_name last_name', 'user_id', ['first_name', 'last_name'])

class UsersList extends Component {

    componentDidMount() {
        this.props.subscribeToUpsert()
    }

    render() {
        return (<ReactTable
            data={this.props.data}
            loading={this.props.loading}
            style={{display: 'flex', flex: 1, fontSize: '14px'}}
            columns={[
                {
                    Header: "User ID",
                    id: 'user_id',
                    accessor: 'user_id'
                },
                {
                    Header: "First Name",
                    id: 'first_name',
                    accessor: 'first_name'
                },
                {
                    Header: "Last Name",
                    id: 'last_name',
                    accessor: 'last_name'
                },
                {
                    Header: "Email",
                    id: 'email',
                    accessor: 'email'
                },
                {
                    Header: "User Role",
                    id: 'user_role_id',
                    accessor: "user_role.description",
                    Filter: ({filter, onChange}) => {
                        return <AUSelectUserRoles className="form-control-sm" value={(filter) ? filter.value : null} onChange={onChange}/>
                    }
                },
                {
                    Header: "Line Manager",
                    id: "line_manager_user_id",
                    accessor: "line_manager.full_name",
                    filterable: true,
                    Filter: ({filter, onChange}) => {
                        return <AUSelectUsers className="form-control-sm" value={(filter) ? filter.value : null} onChange={onChange}/>
                    }
                },
                {
                    Header: "Office",
                    id: 'office_id',
                    accessor: "office.description",
                    Filter: ({filter, onChange}) => {
                        return <AUSelectOffice className="form-control-sm" value={(filter) ? filter.value : null} onChange={onChange}/>
                    }
                },
                {
                    Header: "Active",
                    id: 'active',
                    accessor: 'active',
                    filterable: false
                }

            ]}
            className="-striped -highlight"
            onFetchData={debounce((state, instance) => this.props.onFetchData(state, instance), 500, {
                leading: true,
                trailing: false
            })} // Request new data when things change
            filterable
            manual
            showPagination={true}
            pages={this.props.pages}
            getTrProps={(state, rowInfo) => {
                return {
                    onClick: (e) => {
                        console.log(rowInfo)
                        this.props.history.push(`/users/${rowInfo.original.user_id}`)
                        //Router.push({pathname: '/projects/edit', query: { project_id: rowInfo.original.project_id }})
                    }
                }
            }}
        />)
    }
}

UsersList = withRouter(UsersList)

export default class UserTable extends Component {

    state = {
        first_name: '',
        last_name: '',
        user_role_id: null,
        email: '',
        line_manager_user_id: null,
        office_id: null,
        limit: 10,
        offset: 0
    }

    fetchData = (state, instance) => {

        console.log('filter', state.pageSize, state.page)

        let filters = state.columns.reduce((carry, column) => {
            if (column.hasOwnProperty('id')) {
                const filterValue = state.filtered.find(({id}) => id === column.id)
                carry[column.id] = (filterValue) ? filterValue.value : ''
            }
            return carry
        }, {})

        this.setState(Object.assign({}, filters, {limit: state.pageSize, offset: state.pageSize * state.page}))
    }

    render() {

        const {first_name, last_name, user_role_id, email, line_manager_user_id, office_id, limit, offset} = this.state
        return (<Query query={QUERY} fetchPolicy="no-cache" variables={{
            first_name,
            last_name,
            user_role_id,
            email,
            line_manager_user_id,
            office_id,
            limit,
            offset
        }}>
            {(result) => {

                const data = (result.data && result.data.filter_users) ? result.data.filter_users : []

                console.log('users', data)

                return (
                    <UsersList
                        loading={result.loading}
                        data={data}
                        pages={Math.ceil(result.data.filter_users_total / limit)}
                        onFetchData={this.fetchData}
                        subscribeToUpsert={() => {
                            /*return result.subscribeToMore(
                                {
                                    document: SUBSCRIPTION,
                                    variables: {
                                        project_id,
                                        name,
                                        project_status_id,
                                        project_director_id,
                                        project_manager_id,
                                        project_clients
                                    },
                                    updateQuery: (prev, {subscriptionData}) => {

                                        if (!subscriptionData.data) {
                                            return prev
                                        }

                                        let data = {}

                                        //does the record already exist using the uniqueKey
                                        const existingRecordIndex = prev.filter_projects.findIndex(data => data.project_id === subscriptionData.data.projectsUpserted.project_id)

                                        if (existingRecordIndex !== -1) {
                                            data['filter_projects'] = [
                                                ...prev.filter_projects.slice(0, existingRecordIndex),
                                                {...subscriptionData.data.projectsUpserted},
                                                ...prev.filter_projects.slice(existingRecordIndex + 1)
                                            ]
                                        }
                                        else {
                                            data['filter_projects'] = [...prev.filter_projects, subscriptionData.data.projectsUpserted]
                                        }


                                        return data
                                    }
                                }
                            )*/
                        }}/>

                )
            }}
        </Query>)
    }

}